import { fork } from 'redux-saga/effects';

import { actions } from 'domain/coupon';
import { itemNavigator } from 'sagas/common';
import { editableFields } from './index';

export default function* navigator(args) {
  yield fork(itemNavigator, { modelName: 'Coupon', actions, editableFields }, args);
}
